import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

// Loading spinner
function LoadingScreen() {
  return (
    <div style={{
      minHeight: "100vh", display: "flex",
      alignItems: "center", justifyContent: "center",
      background: "#f4fbf4", flexDirection: "column", gap: 14,
      fontFamily: "'Outfit', sans-serif",
    }}>
      <div style={{
        width: 24, height: 24,
        border: "2.5px solid #c8e6c9",
        borderTopColor: "#2e7d32",
        borderRadius: "50%",
        animation: "spin .7s linear infinite",
      }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
      <span style={{ fontSize: 13.5, color: "#6b7c6d" }}>Loading…</span>
    </div>
  );
}

/**
 * ProtectedRoute
 * allowedRoles: array of roles that can access this route
 * e.g. allowedRoles={['super_admin']}
 */
export default function ProtectedRoute({ children, allowedRoles }) {
  const { profile, loading } = useAuth();

  if (loading) return <LoadingScreen />;

  // Not logged in → go to login
  if (!profile) return <Navigate to="/" replace />;

  // Wrong role → go to their correct dashboard
  if (allowedRoles && !allowedRoles.includes(profile.role)) {
    const redirectMap = {
      super_admin: '/admin/dashboard',
      hoa_admin:   '/hoa/dashboard',
      valet:       '/valet/dashboard',
      resident:    '/resident/dashboard',
    };
    return <Navigate to={redirectMap[profile.role] || '/'} replace />;
  }

  return children;
}